module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary is-fullheight with-bg-image"
  }, [_c('herobody'), _vm._v(" "), _c('herofoot', {
    attrs: {
      "tabs": _vm.tabs
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48f2aec4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero/hero.vue
// module id = 272
// module chunks = 2